import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pkpPaginate' })
export class PaginatePipe implements PipeTransform {
    transform<T>(value: T[], pageSize: number, currentPage: number): T[] {
        return value.slice(
            Math.max(pageSize * (currentPage - 1), 0),
            pageSize * currentPage
        );
    }
}
